export default __webpack_public_path__ + "static/media/1-piece-mantle.75563bfb.svg";